/**
 * Created by karora on 11/10/19.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { HubCount } from '../types/hub-count';

@Component({
  selector: 'dash-health-counts',
  template: `<div class="active-counts">
  <div *ngFor="let count of hubCounts" class="health-counts"
       [style.color]="this.getColorFor(count.hub_health)"
       [style.background-color]="this.getBackgroundFor(count.hub_health)"
       (click)="gotoHealth(count.hub_health)">
    <span class="health-group">{{count.hub_health}}</span>
    <span class="group-count">{{count.count}}</span>
  </div>
</div>
`,
  styles: [
    `.active-counts { display: block; width: 100% }`,
    `.health-counts {
      display: inline-block;
      width: 10em;
      margin: 0 0.5em 0.5em 0.5em;
      padding: 0.1em 0.5em;
      color: #202020;
    }`,`
    .health-counts:hover {
      color: white;
      background-color: #607D8B;
    }`,`
    .health-group {
      display: inline-block;
      width: 7em;
      line-height: 3em;
      vertical-align: middle;
    }`,`
    .group-count {
      display: inline-block;
      width: 2em;
      line-height: 3em;
      vertical-align: middle;
      text-align: right;
    }`
  ],
})

export class DashHealthCountsComponent implements OnInit {
  hubCounts: HubCount[] = [];
  errorMessage: string;

  constructor(
    private hubService: HubService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.hubService.getHubCounts().subscribe(
      hubCounts => this.hubCounts = hubCounts,
      error => this.errorMessage = <any>error,
    );
  }

  gotoHealth(hub_health: string): void {
    let there = '';
    if (hub_health) { there = hub_health.substr(0, 1); }
    this.router.navigate(['/hubs/health/', there ]);
  }

  getColorFor(hub_health: string): string {
    if (hub_health) {
      switch (hub_health.substr(0, 1)) {
        case 'A':
          return '#202020';
        case 'B':
          return '#202020';
        case 'C':
          return '#202020';
        case 'D':
          return '#202020';
        case 'E':
          return '#ffffff';
        case 'F':
          return '#ffffff';
        case 'G':
          return '#202020';
      }
    }
    return '#ffffff';
  }

  getBackgroundFor(hub_health: string): string {
    if (hub_health) {
      switch (hub_health.substr(0, 1)) {
        case 'A':
          return '#eeeeee';
        case 'B':
          return '#efecec';
        case 'C':
          return '#f0e8e8';
        case 'D':
          return '#f2e0e0';
        case 'E':
          return '#f4d0d0';
        case 'F':
          return '#f8c0c0';
        case 'G':
          return '#eeeeee';
      }
    }
    return '#f840e0';
  }

}
